import {
  adminRoleKeys,
  agencyAdminRoleKeys,
  agencyRoleKeys,
  agentRoleKeys,
  brandRoleKeys,
  masterAdminRoleKeys,
  providerRoleKeys,
} from '@functions/role'

export function isAdmin(roleKey: string) {
  return adminRoleKeys.includes(roleKey)
}

export function isMasterAdmin(roleKey: string) {
  return masterAdminRoleKeys.includes(roleKey)
}

export function isAgencyAdmin(roleKey: string) {
  return agencyAdminRoleKeys.includes(roleKey)
}

export function isAgent(roleKey: string) {
  return agentRoleKeys.includes(roleKey)
}

export function isAgencyUser(roleKey: string) {
  return agencyRoleKeys.includes(roleKey)
}

export function isProviderUser(roleKey: string) {
  return providerRoleKeys.includes(roleKey)
}

export function isBrandUser(roleKey: string) {
  return brandRoleKeys.includes(roleKey)
}
